import './product.component.scss'
import './product-control.scss'
import './product-line.scss'
import './product-line.js'
import './product-gallery.js'
import { ProductControl } from './product-control.js'
import { ProductSummary } from './product-summary.js'

class Product {
  constructor(root) {
    this.root = root
    this.controls = this.createControls()
    if (this.controls.length > 0) {
      this.summary = new ProductSummary(this.controls)
    }
    this.historyHandler()
    /*if (document.documentElement.classList.contains('no-touchevents')) {
      this.createGallery()
    }*/
  }

  historyHandler() {
    sessionStorage.setItem('product_visited', 1)
  }

  createControls() {
    const controls = []
    this.root.querySelectorAll('.product-control').forEach((el) => {
      controls.push(new ProductControl(el))
    })
    return controls
  }

  /*createGallery() {
    let zoomInit = false
    const zoomers = new Map()
    document.querySelectorAll('[data-zoom]').forEach((zoom) => {
      const { zoom: src } = zoom.dataset
      zoomers.set(zoom, src)

      zoom.addEventListener('mousemove', (e) => {
        const x = (e.offsetX / zoom.offsetWidth) * 100
        const y = (e.offsetY / zoom.offsetHeight) * 100
        zoom.style.backgroundPosition = x + '% ' + y + '%'
      })
    })
    const initZoomers = () => {
      if (zoomInit) return false
      zoomers.forEach((src, element) => {
        element.style.backgroundImage = `url(${src})`
      })
      zoomInit = true
    }
    window.addEventListener('scroll', initZoomers, { once: true })
    window.addEventListener('mousemove', initZoomers, { once: true })
  }*/
}

const products = document.querySelectorAll('.product')
products.forEach((root) => new Product(root))
if (products.length > 0) {
  import(/* webpackChunkName: 'fslightbox' */ 'fslightbox')
}
